import AxiosClient from "../../../services/axios.services";

class RequestTrackingServices {
  getRequestTracking = (params) =>
    AxiosClient.get("/api/app/seleccion_contratacion_postulante_plaza/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getRequestTrackingById = (id) =>
    AxiosClient.get(`/api/app/seleccion_contratacion_postulante_plaza/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveRequestTracking = (data) =>
    AxiosClient.post(
      "/api/app/seleccion_contratacion_postulante_plaza/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editRequestTracking = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_postulante_plaza/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteRequestTracking = (id) =>
    AxiosClient.delete(
      `/api/app/seleccion_contratacion_postulante_plaza/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    mailSendRequestTracking = (data) =>
    AxiosClient.post(`/api/app/envio_correo_seleccion_contratacion/`, data,
      {
        headers: { "Content-Type": "application/json" }
      }
    );
}

export default new RequestTrackingServices();
